/**
 * 多语言
 * @url https://github.com/alibaba/react-intl-universal
 */

import intl from 'react-intl-universal';
import en from './en-US';
import zh from './zh-CN';
// import ja from './ja-JP'
// import ko from './ko-KR'

import 'moment/locale/es-us';
import 'moment/locale/zh-cn';

export const localesList = {
  'en-US': en,
  'zh-CN': zh,
  // 'ja-JP': ja,
  // 'ko-KR': ko,
};

// 设置初始化语言包
export const intlInit = (currentLocale: string, callBack?: () => void) => {
  intl
    .init({
      currentLocale,
      locales: localesList,
    })
    .then(() => {
      callBack?.();
    });
};

export const intlGet = (key?: string, val?: unknown): string =>
  key ? intl.get(String(key), val) : '';

export const intlGetHTML = (key?: string, val?: any): string =>
  key ? intl.getHTML(String(key), val) : '';

// 获取语种对应语言
export const intlGetLanguage = (value: any) =>
  value && (intl.get(`COMMON.LANG.${value}`) || value);
// 获取地点对应语言
export const intlGetCountry = (value: any) =>
  value && (intl.get(`COMMON.COUNTRY.${value}`) || value);
// 获取接口code对应语言
export const intlGetApiError = (value: any, params?: unknown) =>
  intl.get(`API.ERROR.CODE.${value}`, params) || '';
// 获取nest接口code对应语言
export const intlGetNestApiError = (value: any, params?: unknown) =>
  intl.get(`API.ERROR.CODE.NEST.${value}`, params) || '';
